import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import * as Styles from './styles';
// CIRCLE_WIDTH_RATIO é uma pequena compensação ótica pra que apareça a borda do círculo com
// mais definição em tamanhos muito pequenos ou muito grandes, usei 6,75% que funcionou
// melhor com os stroke widths de 1, 2 ou 4 px que eu testei.
const CIRCLE_WIDTH_RATIO = 0.0675;
const DEFAULT_SIZE = 120;
const DEFAULT_STROKE_WIDTH = 4;
const DEFAULT_FILL_TOKEN = '--color-secondary-100';
const INTERNAL_VALUE_DEFAULT_FILL_TOKEN = '--color-neutral-130';
const BACKGROUND_DEFAULT_FILL_TOKEN = '--color-neutral-110';
const capPercentage = percent => {
  if (percent > 100) return 100;
  if (percent < -100) return -100;
  return percent;
};
const capSize = size => {
  if (size <= 0) return DEFAULT_SIZE;
  return size;
};
/**
 * Componente ProgressCircle do Design System OLX
 */
export const ProgressCircle = _ref => {
  let {
    size = DEFAULT_SIZE,
    strokeWidth = DEFAULT_STROKE_WIDTH,
    fill = DEFAULT_FILL_TOKEN,
    backgroundFill = BACKGROUND_DEFAULT_FILL_TOKEN,
    internalValueColor = INTERNAL_VALUE_DEFAULT_FILL_TOKEN,
    internalValue,
    percentage
  } = _ref;
  const realSize = capSize(size);
  const coords = realSize / 2;
  const radialDiff = realSize * CIRCLE_WIDTH_RATIO;
  const radius = coords - radialDiff;
  const circumference = 2 * Math.PI * radius;
  return React.createElement(Styles.ProgressCircleWrapper, {
    "data-ds-component": "DS-ProgressCircle",
    internalValue: internalValue,
    size: realSize,
    internalValueColor: internalValueColor
  }, React.createElement("svg", {
    width: realSize,
    height: realSize
  }, React.createElement(Styles.SVGCircle // círculo cinza no fundo
  , {
    circumference: circumference,
    percentage: 100,
    strokeWidth: strokeWidth,
    fill: backgroundFill,
    r: radius,
    cx: coords,
    cy: coords
  }), React.createElement(Styles.SVGCircle // círculo que mede o progresso
  , {
    circumference: circumference,
    percentage: capPercentage(percentage),
    strokeWidth: strokeWidth,
    fill: fill,
    r: radius,
    cx: coords,
    cy: coords
  })));
};
ProgressCircle.displayName = 'ProgressCircle';